<div class="language-switcher" *ngIf="!shouldHideSelector">
  <div class="selected-language" (click)="toggleDropdown()" [title]="getTooltipText()">
    <img [src]="getFlagUrl(selectedLanguage.flag)" [alt]="selectedLanguage.name" class="flag-icon">
    <span class="language-name">{{ selectedLanguage.name }}</span>
    <span class="user-override-indicator" *ngIf="hasUserOverride" [title]="getAutoIndicatorTooltip()">⚡</span>
    <span class="auto-indicator" *ngIf="isUrlBasedLanguage && !hasUserOverride" [title]="getAutoIndicatorTooltip()">●</span>
    <svg class="dropdown-arrow" [class.open]="isDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none">
      <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  
  <div class="language-dropdown" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
    <div class="language-option" 
         *ngFor="let language of languages" 
         (click)="selectLanguage(language)"
         [class.selected]="language.code === selectedLanguage.code">
      <img [src]="getFlagUrl(language.flag)" [alt]="language.name" class="flag-icon">
      <span class="language-name">{{ language.name }}</span>
    </div>
  </div>
</div>

